// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"wi_a bht_b"};